import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {Router} from '@angular/router';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {ChapterCountryModel} from '@shared/models/chapter.models';
import {Location} from '@angular/common';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';

@Injectable({
  providedIn: 'root'
})

export class PlatformToolGmtChaptersHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  selectedCountry: any;
  triggerSelector: boolean;
  selectedCountryCode: string;
  publishedCountries: ChapterCountryModel[];
  constructor(private dialogService: DialogService, private router: Router, private location: Location,
              private platformQueryService: PlatformQueryService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }

  destroy(): void {
    this.invalidateSubject.close();
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    switch (command.name) {
      case 'SelectCountryCommand':
        this.getPublishedCountry(command);
        break;
      default:
        break;
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
  }

  magicLinkModelValueChangedHandler(payload: any) {
    this.magicLinkModelValueChanged.emit(payload);
  }
  onCountrySelect(command: PlatformCommand) {
    console.log('=>  Country selected and making trigger selector true');
    const dialogModel = DialogModel.create(
      'Select Country',
      'ChaptersCountrySelectorDialogComponent',
      {
        countries: this.publishedCountries,
        selectedCountry: this.publishedCountries.find(country => country.code === command.fieldValues['CountryFlag'])
      },
      '630px',
      '630px'
    );
    dialogModel.okCaption = 'Done';
    dialogModel.cancelCaption = 'Cancel';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.data.input.selectedCountry) {
        this.onCountryChange(res.data.input.selectedCountry);
      }
    });
  }

  private onCountryChange(country) {
    if (country?.code === this.selectedCountry?.code) {
      this.triggerSelector = false;
      console.log('=> country already selected... returning');
      this.syncRouteParam(country.code);
      return;
    }
    console.log('===> Dispatching set country action');
    this.syncRouteParam(country.code);
    this.selectedCountry = country;
    // this.chapterDocumentStore.dispatch(new SetCountryAction(this.documentDefinitionId, country));
  }


  private syncRouteParam(countryCode: string) {
    console.log(`===> Syncing route param with country code ` + countryCode);
    const urlTree = this.router.parseUrl(this.router.url);
    console.log('====> syncing ....');
    if (urlTree.root.children.primary.segments) {
      let foundIndex = -1;
      const segments = urlTree.root.children.primary.segments;

      for (let i = 0; i < segments.length; i++) {

        if (segments[i].path === countryCode ) {
          return;
        }

        if (segments[i].path.toUpperCase() === segments[i].path ) {
          foundIndex = i;
          break;
        }
      }
      if (foundIndex > -1 ) {
        urlTree.root.children.primary.segments = urlTree.root.children.primary.segments.slice(0, foundIndex);
      }
      const url = urlTree.toString();
      const navigationUrl = `${url}/${countryCode}`;
      this.router.navigateByUrl(navigationUrl);
      return;
    }

    if (this.router.url.slice(-1).toUpperCase() === this.router.url.slice(-1)) {
      let url = this.router.url;
      url = url.slice(0, url.length - 2);
      // console.log('Url is : ' + url);
      this.location.replaceState(url);
      // this.router.navigateByUrl(`${url}${countryCode}`);
    } else {
      // console.log('Url is : ' + `${this.router.url}/${countryCode}`);
      this.location.replaceState(`${this.router.url}/${countryCode}`);
      // this.router.navigateByUrl(`${this.router.url}/${countryCode}`);
    }
  }

  private getPublishedCountry(command: PlatformCommand) {
    const platformQuery = new PlatformQuery();
    platformQuery.name = 'GetCountryMaterialsPublishedCountriesQuery';
    platformQuery.api = Api.Chapters;
    this.platformQueryService.executeQuery(platformQuery).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreenService.hide();
      this.publishedCountries = response.fieldValues['Countries'];
      this.onCountrySelect(command);
    });
  }
}
